import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output
} from '@angular/core';
import { IDynamicallyCreatedComponent } from '../../core-data-model';
import { TranslationService } from '../../translations';

@Component({
    styles: [
        '.vmModalTitle { margin-top: 20px;}',
        '.vmModalBodyText { padding: 10px 30px 0px 30px}'
    ],
    template: `
        <div class="value-metrics-head"></div>
        <div class="pi-modalBody_simpleText">
            <div class="title-md vmModalTitle" piTesting="value-metrics-title">
                {{ TR.key('value-metrics.modal.title') }}
            </div>
            <div
                class="subtitle-md vmModalBodyText"
                [innerHTML]="bodyText"
            ></div>
        </div>
        <div class="pi-modalFooter">
            <div class="btn--lsg_centeredContainer">
                <button
                    type="button"
                    class="button button-md button-primary"
                    (click)="confirmRequest(true)"
                    piTesting="value-metrics-continue"
                >
                    {{ TR.key('value-metrics.modal.yesContinue') }}
                </button>
                <button
                    type="button"
                    class="button button-md  button-tertiary"
                    (click)="confirmRequest(false)"
                    piTesting="value-metrics-cancel"
                >
                    {{ TR.key('text.common-terms.cancel') }}
                </button>
            </div>
        </div>
    `,
    standalone: false
})
export class ValueMetricsModalComponent
    implements IDynamicallyCreatedComponent, OnDestroy
{
    @Output()
    readonly confirm = new EventEmitter();

    @Input() bodyText: string = null;

    outputEvents = ['confirm'];
    subscriptions: any[];

    get propertiesList(): string[] {
        return ['bodyText'];
    }

    constructor(public TR: TranslationService) {}

    confirmRequest(isConfirmed: boolean) {
        this.confirm.emit(isConfirmed);
    }

    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => {
                subscription.unsubscribe();
            });
        }
    }
}
